export const formatCurrency = (amount: number, currencyCode = 'CAD'): string => {
  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
  });
  return formatter.format(amount);
};
